(function () {
  var root = document.querySelector('[data-swx-hero]');
  if (!root || root.dataset.swxReady) return;
  root.dataset.swxReady = '1';
  window.swxLoad3D(root).then(init).catch(function (e) { console.error('swapex hero', e); });

  function init(gltf) {

  var canvas = root.querySelector('[data-swx-canvas]');
  var copy = root.querySelector('[data-swx-copy]');
  var hint = root.querySelector('[data-swx-hint]');
  var stats = Array.prototype.slice.call(root.querySelectorAll('[data-swx-stat]'));

  var clamp = function (v, a, b) { return Math.min(b, Math.max(a, v)); };
  var smooth = function (e0, e1, x) { var t = clamp((x - e0) / (e1 - e0), 0, 1); return t * t * (3 - 2 * t); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var easeInOut = function (t) { return t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2; };

  // Measured from the GLB. The model's native pose is lid-OPEN; +2.007 rad about X closes it.
  var AIRPODS_HINGE = new THREE.Vector3(0, 0.13, -0.995);
  var AIRPODS_LID_CLOSED = 2.007;

  var renderer;
  try {
    renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
  } catch (e) {
    root.classList.add('swx-hero--nowebgl');
    return;
  }
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 1.5));
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;

  var scene = new THREE.Scene();
  var camera = new THREE.PerspectiveCamera(32, 1, 0.1, 200);
  var pmrem = new THREE.PMREMGenerator(renderer);
  scene.environment = pmrem.fromScene(new THREE.RoomEnvironment(), 0.04).texture;
  scene.add(new THREE.HemisphereLight(0xdfe9ff, 0x0a0e18, 0.35));
  var key = new THREE.DirectionalLight(0xffffff, 2.4); key.position.set(5, 8, 6); scene.add(key);
  var fill = new THREE.DirectionalLight(0xbfe9ff, 0.8); fill.position.set(-6, 2, 4); scene.add(fill);
  var rim = new THREE.DirectionalLight(0x2fe39b, 1.6); rim.position.set(-4, 5, -6); scene.add(rim);

  var ready = false, model, lid, body, budL, budR, lidPivot, budL0, budR0;

  function onLoaded(g) {
    model = g.scene.clone(true);
    scene.add(model);
    lid = model.getObjectByName('BoFsEvBGaAjKkRU');
    body = model.getObjectByName('zzBtSmxeDxAZRRE');
    budR = model.getObjectByName('szusrxTxeDnOCPF');
    budL = model.getObjectByName('iauArCIBpqmQwBK');
    model.traverse(function (o) { if (o.isMesh && o.material) o.material.envMapIntensity = 1.25; });
    model.updateMatrixWorld(true);
    var b = new THREE.Box3().setFromObject(model);
    var sz = b.getSize(new THREE.Vector3());
    model.scale.setScalar(3.4 / Math.max(sz.x, sz.y, sz.z));
    model.updateMatrixWorld(true);
    b = new THREE.Box3().setFromObject(model);
    model.position.sub(b.getCenter(new THREE.Vector3()));
    model.updateMatrixWorld(true);
    lidPivot = new THREE.Group();
    lidPivot.position.copy(model.localToWorld(AIRPODS_HINGE.clone()));
    scene.add(lidPivot);
    lidPivot.attach(lid);
    scene.attach(budL);
    scene.attach(budR);
    budL0 = budL.position.clone();
    budR0 = budR.position.clone();
    ready = true;
    root.classList.add('swx-hero--loaded');
    onScroll();
  }

  onLoaded(gltf);

  var lastIdx = -1;
  function update(p) {
    dirty = true;
    if (!ready) return;
    var mobile = window.innerWidth <= 980;
    var az = lerp(0.0, 0.26, easeInOut(p));
    var el = lerp(-0.86, 1.12, smooth(0.08, 1, p));
    var asp = camera.aspect || 1;
    var stacked = root.classList.contains('swx-hero--stack');
    var dist = lerp(11.8, 13.9, smooth(0.3, 1, p)) * (stacked ? Math.max(0.6, 0.5 / asp) : Math.max(1, 0.66 / asp));
    var panX = mobile ? 0 : -0.6;
    camera.position.set(Math.sin(az) * dist + panX, el, Math.cos(az) * dist);
    camera.lookAt(panX, lerp(-0.86, 0.42, smooth(0.1, 1, p)), 0);

    var open = easeInOut(smooth(0.05, 0.4, p));
    lidPivot.rotation.x = lerp(AIRPODS_LID_CLOSED, 0, open);

    var seatY = -1.45;
    var riseT = easeInOut(smooth(0.45, 0.96, p));
    var yOff = lerp(seatY, 0, riseT);
    var zPull = lerp(-0.18, 0, riseT);
    budL.position.set(budL0.x, budL0.y + yOff, budL0.z + zPull);
    budR.position.set(budR0.x, budR0.y + yOff, budR0.z + zPull);
    budL.visible = budR.visible = open > 0.6;
    rim.intensity = 1.6 + riseT * 1.1;

    if (copy) {
      copy.style.transform = mobile ? 'none' : 'translateY(calc(-50% - ' + (p * 16) + 'px))';
      copy.style.opacity = '1';
    }
    if (hint) hint.style.opacity = (1 - smooth(0.04, 0.22, p)).toFixed(3);
    if (stats.length) {
      var idx = Math.min(stats.length - 1, Math.max(0, Math.floor(p * stats.length)));
      if (idx !== lastIdx) {
        lastIdx = idx;
        stats.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      }
    }
  }

  // Narrow screens stack copy above the model: the canvas only gets the space below the copy,
  // so the case can never sit on top of the text or buttons, whatever the viewport height.
  function layout() {
    var stick = root.firstElementChild;
    if (window.innerWidth > 980 || !copy || !stick) {
      root.classList.remove('swx-hero--stack');
      canvas.style.top = canvas.style.height = '';
      return;
    }
    root.classList.add('swx-hero--stack');
    var H = stick.clientHeight;
    var band = H < 640 ? 70 : 118;
    var top = copy.offsetTop + copy.offsetHeight + 6;
    var h = Math.max(150, H - top - band);
    canvas.style.top = top + 'px';
    canvas.style.height = h + 'px';
    root.style.setProperty('--swx-mid', Math.round(top + h / 2) + 'px');
    root.style.setProperty('--swx-floor', Math.max(0, Math.round(H - top - h * 0.8)) + 'px');
    root.style.setProperty('--swx-band', band + 'px');
  }

  function resize() {
    layout();
    dirty = true;
    var w = canvas.clientWidth, h = canvas.clientHeight;
    if (!w || !h) return;
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  }

  function onScroll() {
    var r = root.getBoundingClientRect();
    var stick = root.firstElementChild;
    var hh = parseFloat(getComputedStyle(root).getPropertyValue('--sxh-h')) || 0;
    var total = root.offsetHeight - (stick ? stick.offsetHeight : window.innerHeight);
    update(total > 0 ? clamp((hh - r.top) / total, 0, 1) : 0);
  }

  window.addEventListener('resize', function () { resize(); onScroll(); });
  window.addEventListener('scroll', onScroll, { passive: true });

  var visible = true;
  var dirty = true;
  new IntersectionObserver(function (es) { visible = es[0].isIntersecting; dirty = true; }).observe(root);
  (function loop() {
    requestAnimationFrame(loop);
    if (visible && dirty) { dirty = false; renderer.render(scene, camera); }
  })();
  resize();
  onScroll();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { resize(); onScroll(); });
  }
})();
